module.exports = __webpack_public_path__ + "static/media/art31.94a9f75e.jpg";